
import React from 'react';
import { Label, Input, FormGroup, Col } from 'reactstrap';
import styles from '../MyInputs/MyInput.module.scss';
import { Editor } from '@tinymce/tinymce-react';
import htmlStyles from './HtmlEditor.scss';


const htmlEditor = ( props ) => {
    console.log(props)
    
    return (
       
        <FormGroup row className="m-0 mb-4 align-items-center">
            <Col xs="12" sm="4" md="3" lg="2" className={styles["label"] + " secondary-color"}>
                {props.formElem.name}
            </Col>
            
            <Col xs="12" sm="8" md="8" lg="6" className="p-0 pl-1 d-flex align-items-center">
                <div className={styles["html-editor"] + " " + (props.formElem.validity ? "border-secondary-color" : styles["html-editor-invalid"])}>
                <Editor
                    apiKey='oyn3g2an55mnsa95tjsxrec7asj1nip8324yoq1b5lz2t4eu'
                    initialValue={props.formElem.placeholder}
                    value={props.formElem.value}
                    id={props.formElem.id}
                    disabled={props.formElem.readOnly}
                    init={{
                        forced_root_block: false,
                        height: 200,
                        min_height: 120,
                        width: "100%",
                        menubar: false,
                        branding: false,
                        content_style: `body {font-size: 14pt; font-family: 'Josefin Sans', sans-serif; }`,
                        editor_css: htmlStyles,
                        plugins: [
                        'advlist autolink lists link image charmap print preview anchor',
                        'searchreplace visualblocks code fullscreen',
                        'insertdatetime media table paste code help wordcount'
                        ],
                        toolbar:
                        'undo redo | bold italic | removeformat'
                    }}
                    onEditorChange={content=>props.onChangeHandler( content, props.formElem.id)}
                />
                </div>
            </Col>
            {/* { 
                props.validity === "is-invalid" ? 
                <Col sm={props.feedbackWidth} className="pl-4 font-weight-bold text-danger font-italic">
                    {props.feedback}
                </Col> :
                null
            } */}
        </FormGroup>
    );

};

// const arePropsEqual = (prevProps, nextProps) =>  prevProps.formElem.value === nextProps.formElem.value; 
// export default React.memo(htmlEditor, arePropsEqual);
export default React.memo(htmlEditor);